import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=b8875070&scoped=true"
import script from "./FileList.vue?vue&type=script&lang=js"
export * from "./FileList.vue?vue&type=script&lang=js"
import style0 from "./FileList.vue?vue&type=style&index=0&id=b8875070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8875070",
  null
  
)

export default component.exports